'use strict';

module.exports = function isIosFirefox(ua) {
  ua = ua || global.navigator.userAgent;
  return /FxiOS/i.test(ua);
};




//////////////////
// WEBPACK FOOTER
// ./~/@braintree/browser-detection/is-ios-firefox.js
// module id = 651
// module chunks = 0